import axios from "axios";
import {HOST_API} from "./../configuration/AppConfiguration";

export const isLogged = () => {
    if (localStorage.sesjaUzytkownikaSystemuOSPv2 !== undefined){
        return true
    } else {
        return false
    }
}

export const isAdmin = () => {
    if(isLogged()){
        if (JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2).dostep === '1'){
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

export const isTv = () => {
    if(isLogged()){
        if (JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2).dostep === '3'){
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

export const czyMamC = () => {
    if (JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2).c === '1'){
        return true
    } else {
        return false
    }
}

export const getSesja = () => {
    return JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2)
}

export const getImieNazwisko = () => {
    if (localStorage.sesjaUzytkownikaSystemuOSPv2 !== undefined){
        return JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2).imie + ' ' + JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2).nazwisko
    } else {
        return ''
    }
}

export const getImie = () => {
    if (localStorage.sesjaUzytkownikaSystemuOSPv2 !== undefined){
        return JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2).imie
    } else {
        return ''
    }
}

export const getNazwisko = () => {
    if (localStorage.sesjaUzytkownikaSystemuOSPv2 !== undefined){
        return JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2).nazwisko
    } else {
        return ''
    }
}

export const getNumer = () => {
    if (localStorage.sesjaUzytkownikaSystemuOSPv2 !== undefined){
        return JSON.parse(localStorage.sesjaUzytkownikaSystemuOSPv2).numer
    } else {
        return ''
    }
}

export const logowanie = (haslo: any, numer: string) => {
    return axios({
        method: 'POST',
        url: HOST_API + "login.php",
        headers: {"Content-Type": "text/plain"},
        data: {
            nr: numer,
            pas: haslo
        }
    })
}

export const dodajDyspozycyjnosc = (numer: any, kiedy: any) => {
    return axios({
        method: 'POST',
        url: HOST_API + "insertDyspo.php",
        headers: {"Content-Type": "text/plain"},
        data: {
            numer: numer,
            data: kiedy
        }
    })
}

export const dodajDyspozycyjnoscV2 = (dane: any) => {
    return axios({
        method: 'POST',
        url: HOST_API + "insertDyspoV2.php",
        headers: {"Content-Type": "text/plain"},
        data: dane
    })
}

export const dodajDyspozycyjnoscWG = (dataStart: any, dataKoniec: any) => {
    return axios({
        method: 'POST',
        url: HOST_API + "insertDyspoWG.php",
        headers: {"Content-Type": "text/plain"},
        data: {
            numer: getNumer(),
            imie: getImie(),
            nazwisko: getNazwisko(),
            dataS: dataStart,
            dataK: dataKoniec,
        }
    })
}

export const delEvent = (id: string) => {
    return axios({
        method: 'delete',
        url: HOST_API + "deleteEvent.php",
        headers: {"Content-Type": "text/plain"},
        data: {
            id: id
        }
    })
}

export const delEventNew = (id: string) => {
    return axios({
        method: 'DELETE',
        url: HOST_API + "deleteEventNew.php",
        headers: {"Content-Type": "application/json"},
        data: {
            id: id,
            numer: getNumer()
        }
    })
}

export const zmienHaslo = (nowe: any) => {
    return axios({
        method: 'post',
        url: HOST_API + "zmianahasla.php",
        headers: {"Content-Type": "text/plain"},
        data: {
            nr: getNumer(),
            nowe: nowe
        }
    })
}

export const getKalendarz = () => {
    return axios({
        method: 'POST',
        url: HOST_API + "getKalendarz.php",
        headers: {"Content-Type": "text/plain"}
    })
}

export const getKalendarzWG = () => {
    return axios({
        method: 'POST',
        url: HOST_API + "getKalendarzWG.php",
        headers: {"Content-Type": "text/plain"}
    })
}

export const getUzytkownicy = () => {
    return axios({
        method: 'get',
        url: HOST_API + "uzytkownicy.php"
    })
}

export const getUzytkownik = (numer: any) => {
    return axios({
        method: 'get',
        url: HOST_API + "uzytkownik.php/?numer="+numer
    })
}

export const zmienPrawo = (numer: any, pb: boolean, pc: boolean) => {
    return axios({
        method: 'POST',
        url: HOST_API + "updatePrawo.php",
        headers: {"Content-Type": "text/plain"},
        data: {
            numer: numer,
            pb: pb? 1 : 0,
            pc: pc? 1 : 0
        }
    })
}

export const dodajUzytkownika = (imie: string, nazwisko: string, numer: string) => {
    return axios({
        method: 'post',
        url: HOST_API + "insertuser.php",
        headers: {"Content-Type": "text/plain"},
        data: {
            imie: imie,
            nazwisko: nazwisko,
            numer: numer
        }
    })
}

export const delUser = (numer: string) => {
    return axios({
        method: 'delete',
        url: HOST_API + "deleteuser.php",
        headers: {"Content-Type": "text/plain"},
        data: {
            numer: numer
        }
    })
}

export const wyloguj = () => {
    localStorage.removeItem('sesjaUzytkownikaSystemuOSPv2')
    //window.location('/')
    //window.location.reload()
    window.location.replace('/')
    //this.props.history.push('/')
    console.log('wylogowano')
}

export const scrollToTop = () => {
    let scrollStep = -window.scrollY / (100 / 10)
    let scrollInterval = setInterval(function () {
        if (window.scrollY !== 0) {
            window.scrollBy(0, scrollStep);
        }
        else clearInterval(scrollInterval);
    }, 10);
}

export const isEmpty = (value: any) => {
    return value === undefined || value === null || value === '' || value === 'null';
}
